module.exports = __webpack_public_path__ + "img/主页4.f9ba741e.jpg";